module.exports = __webpack_public_path__ + "media/images/operation_jobs/laundry_net_caution-6f2d1f40845149ddc282222553777bd5.png";